interface ConditionalRule {
  id?: string
  expected_answer?: string
  operator?: string
  question?: number | string
  order?: number | null
  forQuestion?: string
  isNew?: boolean
  [key: string]: any
}

interface ConditionalRuleGroup {
  id?: string
  conditional_rules: ConditionalRule[]
  order?: number | null
  isNew?: boolean
  [key: string]: any
}

interface Question {
  conditional_rule_groups?: ConditionalRuleGroup[]
  [key: string]: any
}

export const addSequentialOrder = (questions: Question[]): Question[] => {
  return questions.map((question) => {
    if (
      !question.conditional_rule_groups ||
      !Array.isArray(question.conditional_rule_groups)
    ) {
      return question
    }

    const updatedConditionalRuleGroups = question.conditional_rule_groups.map(
      (group, groupIndex) => {
        const updatedGroup: ConditionalRuleGroup = {
          ...group,
          order: groupIndex,
        }

        if (group.conditional_rules && Array.isArray(group.conditional_rules)) {
          updatedGroup.conditional_rules = group.conditional_rules.map(
            (rule, ruleIndex) => ({
              ...rule,
              order: ruleIndex,
            })
          )
        }

        return updatedGroup
      }
    )

    return {
      ...question,
      conditional_rule_groups: updatedConditionalRuleGroups,
    }
  })
}

export const addSequentialOrderToGroups = (
  conditionalRuleGroups: ConditionalRuleGroup[]
): ConditionalRuleGroup[] => {
  if (!Array.isArray(conditionalRuleGroups)) {
    return conditionalRuleGroups
  }

  return conditionalRuleGroups.map((group, groupIndex) => {
    const updatedGroup: ConditionalRuleGroup = {
      ...group,
      order: groupIndex,
    }

    if (group.conditional_rules && Array.isArray(group.conditional_rules)) {
      updatedGroup.conditional_rules = group.conditional_rules.map(
        (rule, ruleIndex) => ({
          ...rule,
          order: ruleIndex,
        })
      )
    }

    return updatedGroup
  })
}
